// Arrow-paging for the "Checkout Our Products" carousel.
// Same pattern as cats-carousel.js: scroll the viewport one
// `clientWidth` per click, auto-disable at the start / end.

(function () {
    function init() {
        document.querySelectorAll('.home-checkout').forEach(setup);
    }

    function setup(section) {
        const viewport = section.querySelector('[data-checkout-viewport]');
        const prev = section.querySelector('[data-checkout-prev]');
        const next = section.querySelector('[data-checkout-next]');
        if (!viewport) return;

        const update = () => {
            const max = viewport.scrollWidth - viewport.clientWidth - 2;
            if (prev) prev.disabled = viewport.scrollLeft <= 2;
            if (next) next.disabled = viewport.scrollLeft >= max;
        };

        if (prev) prev.addEventListener('click', () => {
            viewport.scrollBy({ left: -viewport.clientWidth, behavior: 'smooth' });
        });
        if (next) next.addEventListener('click', () => {
            viewport.scrollBy({ left: viewport.clientWidth, behavior: 'smooth' });
        });

        viewport.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
